import { useState } from 'react'
import { useQueryState, parseAsArrayOf, parseAsString } from 'nuqs'

import PageContainer from '@/common/components/PageContainer'
import { useTablePagination } from '@/common/hooks/useTablePaginate'
import { useDateFilter } from '@/common/hooks/useDateFilter'
import useQueryOperatorWithdrawalTransactions from '@/modules/bank/api/hooks/useQueryOperatorWithdrawalTransactions'
import OperatorWithdrawalListing from '@/modules/bank/components/OperatorWithdrawal/components/OperatorWithdrawalListing'

function OperatorWithdrawalPage() {
	const { pageSize, currentPage, searchQuery } = useTablePagination()
	const [status] = useQueryState('status', parseAsArrayOf(parseAsString))

	const { dateFilter } = useDateFilter()

	const [amountSort, setAmountSort] = useState<'asc' | 'desc' | undefined>(
		undefined,
	)
	const [createdAtSort, setCreatedAtSort] = useState<
		'asc' | 'desc' | undefined
	>('desc')

	const handleSort = (columnId: string, order: 'asc' | 'desc' | undefined) => {
		if (columnId === 'amount') {
			setAmountSort(order)
			setCreatedAtSort(undefined)
		} else if (columnId === 'createdAt') {
			setCreatedAtSort(order)
			setAmountSort(undefined)
		}
	}

	const payload = {
		take: pageSize,
		skip: (currentPage - 1) * pageSize,
		search: searchQuery || undefined,
		status: status && status.length > 0 ? status : undefined,
		startDate: dateFilter.startDate || undefined,
		endDate: dateFilter.endDate || undefined,
		sortByCreatedAt: createdAtSort,
		sortByAmount: amountSort,
	}

	const { data, refetch, isLoading } =
		useQueryOperatorWithdrawalTransactions(payload)

	const withdrawalList = data?.data || []
	const totalWithdrawals = data?.total || 0

	return (
		<PageContainer>
			<div className="flex-1 space-y-4">
				<OperatorWithdrawalListing
					data={withdrawalList}
					total={totalWithdrawals}
					onRefresh={refetch}
					isLoading={isLoading}
					onSort={handleSort}
				/>
			</div>
		</PageContainer>
	)
}

export default OperatorWithdrawalPage
